import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/favicon.png";
import brand from "../../assets/sarrthiias-logo.png";

function AnalyticsSidebar() {
    const [expanded, setExpanded] = useState(true);
    const location = useLocation();
    const currentPath = location.pathname;

    const menuItems = [
        { icon: "fa-solid fa-chart-line", text: "Sales Dashboard", link: "/analytics/sales" },
        { icon: "fa-solid fa-users", text: "Transactions Dashboard", link: "/analytics/transactions" },
        { icon: "fa-solid fa-chart-pie", text: "Revenue Dashboard", link: "/analytics/revenue" },
        { icon: "fa-solid fa-chart-bar", text: "Performance Dashboard", link: "/analytics/performance" },
        { icon: "fa-solid fa-bullseye", text: "Leads Dashboard", link: "/analytics/leads" },
        { icon: "fa-solid fa-clock", text: "Contacts Dashboard", link: "/analytics/contacts" },
        { icon: "fa-solid fa-chart-area", text: "Trends Dashboard", link: "/analytics/trends" },
        { icon: "fa-solid fa-cube", text: "Manage Agents", link: "/analytics/manage-agents" }
    ];

    return (
        <aside className="h-screen w-fit">
            <nav className="h-full flex flex-col bg-white border-r shadow-sm">
                <div className="p-4 pb-2 flex justify-between items-center mb-5">
                    <div className="w-full flex justify-center items-center">
                        <img
                            className={`overflow-hidden transition-all ${expanded ? "w-20" : "w-10"}`}
                            src={expanded ? brand : logo}
                            alt="Logo"
                        />
                    </div>
                    <button
                        onClick={() => setExpanded((curr) => !curr)}
                        className="p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100"
                    >
                        {expanded ? (
                            <i className="fa-solid fa-chevron-left"></i>
                        ) : (
                            <i className="fa-solid fa-chevron-right"></i>
                        )}
                    </button>
                </div>

                <ul className="flex-1 px-3">
                    {menuItems.map(({ icon, text, link }) => (
                        <SidebarItem
                            key={link}
                            expanded={expanded}
                            icon={icon}
                            text={text}
                            active={currentPath === link}
                            link={link}
                        />
                    ))}
                </ul>

                <div className="border-t p-3">
                    <Link
                        to="/"
                        className="flex items-center justify-center py-2 px-3 rounded-md hover:bg-blue-50 text-gray-600"
                    >
                        <i className="fa-solid fa-arrow-left"></i>
                        {expanded && <span className="ml-2">Back to Main</span>}
                    </Link>
                </div>
            </nav>
        </aside>
    );
}

function SidebarItem({ icon, text, active, link, expanded }) {
    return (
        <Link
            to={link}
            className={`
                relative flex items-center ${expanded ? "" : "justify-center"} py-2 px-3 my-1
                font-medium rounded-md cursor-pointer
                transition-colors group h-10
                ${
                    active
                        ? "bg-gradient-to-tr from-indigo-200 to-indigo-100 text-indigo-800"
                        : "hover:bg-indigo-50 text-gray-600"
                }
            `}
        >
            <i className={`${icon} w-5`}></i>
            {expanded && <span className="ml-2">{text}</span>}
        </Link>
    );
}

export default AnalyticsSidebar;